//import Vue from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { isUserLoggedIn } from '@/services/authService'
import { getAppTitle } from '@/flavors'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'loginpage',
    component: () => import(/* webpackChunkName: "login" */ '../components/login/SignIn.vue'),
    meta: { noAuthNeeded: true },
    beforeEnter(to, from, next) {
      if(localStorage.getItem('loginFlow') === 'activation-code') {
        next('/school')
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/school',
    name: 'signin-activation-code',
    component: () => import(/* webpackChunkName: "signin-activation-code" */ '../components/login/SignIn.vue'),
    meta: { noAuthNeeded: true },
  },
  {
    path: '/signin',
    name: 'signin-otp',
    component: () => import(/* webpackChunkName: "signin-otp" */ '../components/login/SignInV2.vue'),
    meta: { noAuthNeeded: true }
  },
  {
    path: '/sso',
    name: 'sso',
    component: () => import(/* webpackChunkName: "about" */ '../components/SSOPage.vue'),
    meta: { noAuthNeeded: true }
  },
  {
    path: '/refundpolicy',
    name: 'refundpolicy',
    component: () => import(/* webpackChunkName: "refundpolicy" */ '../components/login/RefundPolicy.vue'),
    meta: { noAuthNeeded: true }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import(/* webpackChunkName: "signup" */ '../components/login/SignUp.vue'),
    meta: { noAuthNeeded: true }
  },
  {
    path: '/learn',
    name: 'learn',
    component: () => import(/* webpackChunkName: "about" */ '../components/learn/LearnPage.vue')
  },
  {
    path: '/myclasses',
    name: 'myclasses',
    component: () => import(/* webpackChunkName: "about" */ '../components/classes/MyClassesPage.vue')
  },
  {
    path: '/mynotifications',
    name: 'mynotifications',
    component: () => import(/* webpackChunkName: "about" */ '../components/notifications/MyNotificationsPage.vue')
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import(/* webpackChunkName: "about" */ '../components/calendar/MyCalendar.vue')
  },
  {
    path: "/ai-rank-predictor",
    name: "ai-rank-predictor",
    component: () => import(/* webpackChunkName: "about" */ "../components/aiRankPredictor/AIRankPredictor.vue"),
  },
  {
    path: "/veeva",
    name: "veeva",
    component: () => import(/* webpackChunkName: "about" */ "../components/veeva/VeevaAIChatBot.vue"),
  },
  {
    path: "/veeva/conversationId=:conversationId",
    name: "veevaConversation",
    component: () => import(/* webpackChunkName: "about" */ "../components/veeva/VeevaConversationView.vue"),
  },
  {
    path: '/combinedreports',
    name: 'combinedReports',
    component: () => import(/* webpackChunkName: "about" */ '../components/combinedReports/CombinedReports.vue')
  },
  {
    path: '/homework',
    name: 'homework',
    children: [
      {
        path: '', name: 'homeworks', component: () => import(/* webpackChunkName: "about" */ '../components/homework/MyHomework.vue')
      },
      {
        path: ':homeworkTaskId/reports/:testId', name: 'homeworkTestReports', component: () => import(/* webpackChunkName: "about" */ '../components/homework/HomeworkResults.vue')
      }
    ],
  },
  {
    path: "/workbook",
    name: "workbook",
    component: () => import(/* webpackChunkName: "about" */ "../components/workbook/WorkbookQuestionFilter.vue"),
  },
  {
    path: "/workbook-v2",
    name: "workbook-v2",
    component: () => import(/* webpackChunkName: "about" */ "../components/workbook/WorkbookQuestionFilterV2.vue"),
  },
{
    path: '/testseries',
    component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestSeriesLayout.vue'),
    children: [
      {
        path: '',
        name: 'collections',
        component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestListPage.vue')
      },
      {
        path: ':collectionId/:type',
        name: 'tests',
        component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestListPage.vue')
      },
      {
        path: ':collectionId/:type/:testId',
        name: 'reports',
        component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestReport/TestReportPage.vue')
      }
    ]
  },
  {
    path: '/starttest/:testId',
    name: 'starttest',
    component: () => import(/* webpackChunkName: "about" */ '../components/Test/StartTestPage.vue')
  },
  {
    path: '/testquestionpage',
    name: 'testquestion',
    component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestQuestionPage.vue')
  },
  {
    path: '/testsubmission',
    name: 'testsubmission',
    component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestSubmissionPage.vue')
  },
  {
    path: '/testresult/:testId',
    name: 'testresult',
    component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestResultPage.vue')
  },
  {
    path: '/practice',
    name: 'practice',
    component: () => import(/* webpackChunkName: "practice" */ '../components/Practice/PracticeListPage.vue')
  },
  {
    path: '/startPracticePage',
    name: 'startPracticePage',
    component: () => import(/* webpackChunkName: "practice" */ '../components/Practice/StartTestPage.vue')
  },
  {
    path: '/PracticeQuestionPage',
    name: 'practiceQuestionPage',
    component: () => import(/* webpackChunkName: "practice" */ '../components/Practice/PracticeQuestionPage.vue')
  },
  {
    path: '/practice/:testId/report',
    name: 'practiceReport',
    component: () => import(/* webpackChunkName: "practice" */ '../components/Practice/Report.vue')
  },
  {
    path: '/selftest',
    name: 'selftest',
    component: () => import(/* webpackChunkName: "selftest" */ '../components/SelfTest/SelfTestPage.vue')
  },
  {
    path: '/selftest/:testId/reports',
    name: 'selftestReports',
    component: () => import(/* webpackChunkName: "selftest" */ '../components/SelfTest/SelfTestReportPage.vue')
  },
  {
    path: '/selftestresult',
    name: 'selftestresult',
    component: () => import(/* webpackChunkName: "selftest" */ '../components/SelfTest/SelfTestResultPage.vue')
  },
  {
    path: '/subjective-tests',
    name: 'subjectiveTestList',
    component: () => import(/* webpackChunkName: "subjectivetest" */ '../components/SubjectiveTest/SubjectiveTestListPage.vue')
  },
  {
    path: '/subjective-starttest/:testId',
    name: 'subjectiveStartTest',
    component: () => import(/* webpackChunkName: "subjectivetest" */ '../components/SubjectiveTest/SubjectiveStartTestPage.vue'),
    props: true
  },
  {
    path: '/subjective-testquestion/:userTestInstanceId',
    name: 'subjectiveTestQuestion',
    component: () => import(/* webpackChunkName: "subjectivetest" */ '../components/SubjectiveTest/SubjectiveTestQuestionPage.vue'),
    props: true
  },
  {
    // Opened on the student's phone from a question's QR code - no login;
    // the signed token in the URL is the credential.
    path: '/subjective-upload/:token',
    name: 'subjectivePhoneUpload',
    component: () => import(/* webpackChunkName: "subjectivetest" */ '../components/SubjectiveTest/SubjectivePhoneUploadPage.vue'),
    props: true,
    meta: { noAuthNeeded: true }
  },
  {
    path: '/subjective-testsubmitted/:userTestInstanceId',
    name: 'subjectiveTestSubmitted',
    component: () => import(/* webpackChunkName: "subjectivetest" */ '../components/SubjectiveTest/SubjectiveTestSubmittedPage.vue'),
    props: true
  },
  {
    path: '/forms',
    name: 'formsList',
    component: () => import(/* webpackChunkName: "about" */ '../components/forms/FormsList.vue'),
  },
  {
    path: '/forms/:formId',
    name: 'formDetail',
    component: () => import(/* webpackChunkName: "about" */ '../components/forms/FormDetail.vue'),
    props: true
  },
 
  {
    path: '/blogs',
    name: 'blogs',
    component: () => import(/* webpackChunkName: "blogs" */ '../components/blogs/BlogList.vue'),
  },
  {
    path: '/blogs/:slug',
    name: 'blog',
    component: () => import(/* webpackChunkName: "blogs" */ '../components/blogs/Blog.vue'),
  },
  {
    path: '/meets',
    name: 'meets',
    component: () => import(/* webpackChunkName: "about" */ '../components/meets/MeetTeacherList.vue'),
  },
  {
    path: '/meets/:teacherId',
    name: 'meetAvailability',
    component: () => import(/* webpackChunkName: "about" */ '../components/meets/MeetTeacherAvailability.vue'),
    props: true
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import(/* webpackChunkName: "terms" */ '../components/TermsAndConditions.vue'),
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const DEFAULT_HOME_PATH = 'learn';
router.beforeEach((to,) => {
  // console.log("from", from);
  // console.log("to", to);
  // console.log("to", store.getters.testRoutingAllowed);

  if (to.path.startsWith('/testseries')) {
    store.commit('appbarVisible', true);
    store.commit('navbarVisible', true);
  }

  if (to.path == '/testquestionpage' && !store.getters.testRoutingAllowed) {
    // console.log("sending user back to test");
    return {
      path: '/testseries',

    }


  }
  if (to.path == '/testsubmission' && !store.getters.testRoutingAllowed) {
    console.log("sending user back to test2");
    return {
      path: '/testseries',

    }
  }
  if (to.path == '/testsubmission' && store.state.isSelfTest) {
    return { path: '/selftestresult' }
  }




  if (!to.meta.noAuthNeeded && !isUserLoggedIn()) {
    return {
      path: '/',
      // save the location we were at to come back later
      //query: { redirect: to.fullPath },
    }
  } else if (to.path === '/' && isUserLoggedIn()) {
    return {
      path: DEFAULT_HOME_PATH
    }
  }
});

//const DEFAULT_TITLE = 'MentoMind';
router.afterEach(() => {
  document.title = getAppTitle(); //DEFAULT_TITLE; //to.meta.title ;
});

export default router
